import React from "react";
import { DiagramBrief, DiagramNetwork, DiagramQuote, DiagramDelivery } from "../components/icons/processDiagrams";

const steps = [
  {
    title: "Tell us about the event",
    description:
      "Share the date, guest count, location, and rough budget. Takes about two minutes — no account or long form required.",
    Diagram: DiagramBrief,
  },
  {
    title: "We curate your essentials",
    description:
      "Decor, cakes, catering, and photography are curated from our network of verified partners, matched to what you've asked for.",
    Diagram: DiagramNetwork,
  },
  {
    title: "Review one clear quote",
    description:
      "A single per-guest price covering everything you've chosen — no separate vendor negotiations or hidden line items.",
    Diagram: DiagramQuote,
  },
  {
    title: "Delivered on schedule",
    description:
      "Your decor, cake, and catering arrive ready for the celebration, in time for the day — you focus on the guests.",
    Diagram: DiagramDelivery,
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-cloud py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h2 className="text-3xl font-bold text-brand sm:text-4xl">How it works</h2>
          <p className="mt-4 text-muted">
            From first message to your event day, in four steps.
          </p>
        </div>

        <div className="mt-14 space-y-14 lg:space-y-20">
          {steps.map((step, index) => {
            const reversed = index % 2 === 1;
            return (
              <div
                key={step.title}
                className={`flex flex-col items-center gap-8 lg:gap-16 ${
                  reversed ? "lg:flex-row-reverse" : "lg:flex-row"
                }`}
              >
                <div className="w-full lg:w-1/2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand text-sm font-semibold text-paper">
                    {index + 1}
                  </span>
                  <h3 className="mt-4 text-xl font-semibold text-charcoal">{step.title}</h3>
                  <p className="mt-2 max-w-md text-muted">{step.description}</p>
                </div>
                <div className="w-full max-w-sm lg:w-1/2 lg:max-w-none">
                  <step.Diagram className="mx-auto max-w-xs lg:max-w-sm" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
